import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';

const UpdatePasswordForm = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage({ type: 'danger', text: 'Parolele nu coincid.' });
      return;
    }
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setMessage({ type: 'danger', text: error.message });
    } else {
      setMessage({ type: 'success', text: 'Parola a fost actualizată cu succes.' });
      setPassword('');
      setConfirmPassword('');
    }
  };

  return (
    <div className="neu-container">
      <strong><h4 className="text-primary-dark">Actualizează Parola</h4></strong>
      <form onSubmit={handlePasswordUpdate}>
        <input
          type="password"
          placeholder="Parolă Nouă"
          className="neu-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <br /><br />
        <input
          type="password"
          placeholder="Confirmă Parola"
          className="neu-input"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <br /><br />
        <button type="submit" className="neumorphism-button-outline">Actualizează Parola</button>
      </form>
      {message.text && (
        <p className={`text-${message.type}`}>{message.text}</p>
      )}
    </div>
  );
};

export default UpdatePasswordForm;
